import React, { useContext } from 'react';
import styles from './NextStepsSection.module.css';
import { MdKeyboardArrowRight } from 'react-icons/md';

import logoShortLight from "../../../assets/images/logo-short-light.svg";
import logoShortDark from "../../../assets/images/logo-short-dark.svg";
import { ThemeContext } from '../../../context/ThemeContext';
import { useTranslation } from '../../../hooks/useTranslation';

interface NextStepsSectionProps {
    title: React.ReactNode;
    steps: Array<{
        title: React.ReactNode;
    }>;
    subtitle?: React.ReactNode;
}

const NextStepsSection: React.FC<NextStepsSectionProps> = ({ title, steps, subtitle }) => {
    const context = useContext(ThemeContext);
    const { t } = useTranslation();

    if (!context) {
        throw new Error('NextStepsSection must be used within a ThemeProvider');
    }

    const { theme } = context;
    const logo = theme === 'dark' ? logoShortDark : logoShortLight;

    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={logo} alt="logo" className={styles.logo} />
                    <h2 className={styles.title}>{title}</h2>
                    <p className={styles.subtitle}>
                        {subtitle || t("service.nextSteps.subtitle")}
                    </p>
                </div>
                <div className={styles.stepsContainer}>
                    {steps.map((step, index) => (
                        <React.Fragment key={index}>
                            <div className={styles.card}>
                                <h3 className={styles.cardTitle}>{step.title}</h3>
                            </div>
                            {index < steps.length - 1 && (
                                <div className={styles.arrow}>
                                    <MdKeyboardArrowRight size={32} />
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default NextStepsSection; 